// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__vOgt9","cell":"ColumnAccessor_cell__zmvzt","firstCellAccent":"ColumnAccessor_firstCellAccent__26Mw1"};